module.exports = __webpack_public_path__ + "static/media/ic-user-alt.10e330b2.svg";